import {
  ApplicationStatementType,
  LoansTerminationValue,
  MajorityShareHolderValue,
} from '../../../Types';
import { updateApplicationStatements } from '../../API';

export interface IPlanActivationSubmitParams {
  applicationId: string;
  companyMajority: string;
  loans?: string;
  ownerName: string;
  ownerPercentage: number;
}

export const submitForm = async ({
  companyMajority,
  loans,
  ownerName,
  ownerPercentage,
  applicationId,
}) => {
  const shouldSaveShareHolder = companyMajority === 'no';
  const statements = [];
  if (companyMajority !== undefined) {
    statements.push({
      type: ApplicationStatementType.MajorityShareHolder,
      value: shouldSaveShareHolder
        ? MajorityShareHolderValue.ShareHolder
        : MajorityShareHolderValue.RegisteredUser,
      extraData: shouldSaveShareHolder
        ? { name: ownerName, sharesPercentage: ownerPercentage }
        : undefined,
    });
  }
  if (loans !== undefined) {
    statements.push({
      type: ApplicationStatementType.LaonsTermination,
      value:
        loans === 'yes'
          ? LoansTerminationValue.OnDueDate
          : LoansTerminationValue.AfterDueDate,
    });
  }
  return await updateApplicationStatements({ statements, applicationId });
};
